/*@ngInject*/
const SystemPreferencesRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getStudioPreferences = function () {
        const url = '/rest/DefaultPreference/studio',
            config = {};

        return this.get(url, config);
    };

    this.saveStudioPreferences = function (studioPreferences) {
        const url = '/rest/DefaultPreference/studio';
        const body = studioPreferences,
            config = {
                params: {}
            };

        return this.post(url, body, config);
    };
};

angular.module('ums.configuration')
    .service('systemPreferencesRepository', SystemPreferencesRepository);
